module.exports = __webpack_public_path__ + "3ae40d3fc824a8a2242f03a3c407a233.svg";